import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

const LandingButton = styled(Button)(({ variant }) => ({
  borderRadius: '20px',
  textTransform: 'none',
  fontWeight: 500,
  padding: '15px 20px',
  fontFamily: 'Mulish, sans-serif',
  fontWeight: 450,
  fontSize: '16px',
  lineHeight: '100%',
  letterSpacing: '0%',
  textAlign: 'center',

  ...(variant === 'contained' && {
    background: 'linear-gradient(309.35deg, #0D3363 -39.44%, #1A68C9 167.41%)',
    color: '#fff',
    '&:hover': {
      background:
        'linear-gradient(309.35deg, #0D3363 -39.44%, #1A68C9 167.41%)',
      opacity: 0.9,
    },
  }),

  ...(variant === 'outlined' && {
    border: '1px solid #134B91',
    color: '#134B91',
    '&:hover': {
      border: '1px solid #134B91',
      backgroundColor: 'rgba(19, 75, 145, 0.04)',
      color: '#134B91',
    },
  }),

  '&.Mui-disabled': {
    opacity: 0.7,
    color: '#fff',
  },
}));

export default LandingButton;
